// extracted by mini-css-extract-plugin
export var actions = "_m8-d";
export var benefitCard = "_m8-a";
export var benefitIcon = "_m8-b";
export var benefitLabel = "_m8-c";
export var benefits = "_m8-9";
export var bodyText = "_m8-8";
export var closeButton = "_m8-2";
export var content = "_m8-3";
export var eyebrow = "_m8-4";
export var heading = "_m8-5";
export var image = "_m8-f";
export var imagePanel = "_m8-e";
export var modal = "_m8-0";
export var shell = "_m8-1";
export var title = "_m8-6";
export var titleOffer = "_m8-7";